import { OwnUpGridOffset } from '@rategravity/own-up-component-library';
import React from 'react';
import slugify from 'slugify';
import {
  FastLinksListWrapper,
  FastLinksList,
  FastLinksListheading,
  FastLinksItem,
  FastLinksOwnUpGridItem,
  Link
} from './components';

type PortableTextProps = {
  blocks: Record<string, any>[];
  wordsCount: number;
};

const generateFastLinksItems = (blocks: Record<string, any>[], wordsCount: number) => {
  const minWordsForToc = 500;
  let items: React.ReactElement[] | null = null;
  if (wordsCount >= minWordsForToc) {
    const headings = blocks?.filter(
      (block: any) => block._type === 'block' && block.style === 'h2'
    );
    if (headings?.length)
      items = headings.map((heading: any) => {
        const slug = slugify(heading.children[0].text, { lower: true });
        return (
          <FastLinksItem key={slug}>
            <Link href={`#${slug}`}>{heading.children[0].text}</Link>
          </FastLinksItem>
        );
      });
  }
  return items;
};

const FastLinks = ({ blocks, wordsCount }: PortableTextProps) => {
  const fastLinkItems = generateFastLinksItems(blocks, wordsCount);

  return fastLinkItems && wordsCount > 500 ? (
    <FastLinksOwnUpGridItem xs={12} md={12} lg={2}>
      <FastLinksListWrapper>
        <FastLinksListheading variant="body1">Fast Links</FastLinksListheading>
        <FastLinksList>{fastLinkItems}</FastLinksList>
      </FastLinksListWrapper>
    </FastLinksOwnUpGridItem>
  ) : (
    <OwnUpGridOffset xs={0} md={2} />
  );
};

export default FastLinks;
